export default __webpack_public_path__ + "static/media/person_outline.e49f7056.svg";